const offerlettervalidate = async (name, value, formData) => {

    let error = { status: false, message: '' }
    let isField = schema[name];

    if (isField) {
        let validation = isField;
        for (let i = 0; i < validation.length; i++) {
            switch (validation[i]) {
                case 'required':
                    if (value == '') {
                        error = { status: true, message: `This Field is required*` };
                        return error;
                    }
            }
        }
    }
    return error;
}
const schema = {
    '#emailOfferDate#' : ['required'],
    '#emailOfferLetterExpiredDate#': ['required'],
    '#emailCandidateFullName#': ['required'],
    '#emailAadharAddress#': ['required'],
    '#emailCandidateFirstName#': ['required'],
    '#emailbasicAmount#': ['required'],
    '#emailJobTitle#': ['required'],
    '#emailJoiningLocation#' : ['required'],
    '#emailJoiningDate#': ['required'],
    '#emailHRA#': ['required'],
    '#emailSplAllow#': ['required'],
    '#emailConvAllow#': ['required'],
    '#emailNPS#' : ['required'],
    '#emailPF(Monthly)#' : ['required'],
    '#emailIncentive#' : ['required'],
}
export default offerlettervalidate;
